import { bindable } from 'aurelia-framework';

export const NotificationEvent = {
	PredictionSaved		:"PredictionSaved",
	PredictionRemoved	:"prediction:removed",
	PredictionDownload	:"prediction:download",
	SysError			:"sys:error",
	SysMessage			:"sys:message"
}

export class Notification {
	@bindable push_message
}
